import React from "react";
import { StatCard, StatCardLoading } from "../common/StatCard";
import { Container, Grid, Skeleton } from "@mui/material";
import { toShortNumber } from "../../lib/util";
import styles from "../../styles/common/index.module.css";

export const ChallengeQuickStats = (props: any) => {
  return (
    // <Grid item>
    //   <Grid container spacing={2} justifyContent="center" item>
    //     <Grid item key={0}>
    //       <StatCard
    //         desc="Challenge Amount"
    //         stat={toShortNumber(props.challenge_stats.challenge_amount)}
    //         color={5}
    //       />
    //     </Grid>
    //     <Grid item key={1}>
    //       <StatCard
    //         desc="Proposals"
    //         stat={toShortNumber(props.challenge_stats.total_proposals)}
    //         color={1}
    //       />
    //     </Grid>

    //     <Grid item key={3}>
    //       <StatCard
    //         desc="Amount Requested"
    //         stat={toShortNumber(props.challenge_stats.amount_requested)}
    //         color={2}
    //       />
    //     </Grid>
    //     <Grid item key={4}>
    //       <StatCard
    //         desc="Funded Proposals"
    //         stat={toShortNumber(props.challenge_stats.funded_proposals)}
    //         color={3}
    //       />
    //     </Grid>
    //     <Grid item key={5}>
    //       <StatCard
    //         desc="Funded Amount"
    //         stat={toShortNumber(props.challenge_stats.funded_amount)}
    //         color={4}
    //       />
    //     </Grid>
    //   </Grid>
    // </Grid>
    <div
      className={styles.second_outer}
      style={{ marginBottom: "-30px !important", marginTop: "5px" }}
    >
      <div className={styles.statistic_dv}>
        <Container>
          <div className={styles.statistic_inner}>
            <div className={styles.statistic1}>
              <h2>
                {toShortNumber(props.challenge_stats.total_proposals, "comma")}
                <span>Proposals</span>
              </h2>
            </div>
            <div className={styles.statistic1}>
              <h2>
                {toShortNumber(props.challenge_stats.funded_proposals, "comma")}
                <span>Projects</span>
              </h2>
            </div>
            <div className={styles.statistic1}>
              <h2>
                ${toShortNumber(props.challenge_stats.challenge_amount)}
                <span>Challenge Amount</span>
              </h2>
            </div>

            <div className={styles.statistic1}>
              <h2>
                ${toShortNumber(props.challenge_stats.amount_requested)}
                <span>Amount Requested</span>
              </h2>
            </div>

            <div className={styles.statistic1}>
              <h2>
                ${toShortNumber(props.challenge_stats.funded_amount)}
                <span>Funded Amount</span>
              </h2>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export const ChallengeQuickStatsLoading = () => {
  return (
    <div
      className={styles.second_outer}
      style={{ marginBottom: "-30px !important", marginTop: "5px" }}
    >
      <Container>
        <div className={styles.statistic_inner}>
          {Object.keys([1, 2, 3, 4, 5]).map((item: any, index) => (
            <div className={styles.statistic1} key={index}>
              {/* <h2> */}
              <Skeleton variant="text" sx={{ fontSize: "2rem" }} width={80} />
              <Skeleton variant="text" sx={{ fontSize: "2rem" }} />
              {/* </h2> */}
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};
